var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copy-main-container",class:{
		left: _vm.margin !== 'right',
		right: _vm.margin === 'right',
		button: _vm.button
	}},[_c('input',{ref:"copy-this",class:{ 'copiar-text-copy': true, 'hideText': _vm.hideText },attrs:{"type":"text","readonly":""},domProps:{"value":_vm.text}}),_c('span',{attrs:{"title":"Copiar","data-text-icon":_vm.iconText},on:{"click":function($event){return _vm.copy()}}},[_c('i',{staticClass:"far fa-copy"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }